import React from "react";
import "./RefreshingState.scss";

interface RefreshingStateProps {
  refreshing: boolean;
  children: React.ReactNode;
}

const RefreshingState = ({ refreshing, children }: RefreshingStateProps) => {
  return (
    <div
      className={`template-refreshing${refreshing ? " template-refreshing--active" : ""}`}
      aria-busy={refreshing}
    >
      {children}
    </div>
  );
};

export default RefreshingState;
